import { Entity } from "./const";

export default {
  [Entity.IS_AUTHENTICATED]: false,
  [Entity.USER]: null,
};
